import type React from "react";

import { LoadingIcon } from "@/components/CustomIcons/LoadingIcon";

interface FahStatsCardProps {
  label: string;
  value: React.ReactNode;
  isLoading?: boolean;
}

export function FahStatsCard({ label, value, isLoading }: FahStatsCardProps): React.ReactNode {
  return (
    <div className="flex min-w-40 flex-col gap-2 rounded-lg bg-white p-4">
      <span className="whitespace-nowrap text-body-bold">{label}</span>
      <h3 className="text-headline2">{isLoading ? <LoadingIcon className="mx-auto size-10" /> : value}</h3>
    </div>
  );
}
